import React, { Component } from 'react'
import './App.css';
import KnowledgeGraph from './comps/KnowledgeGraph';
import Safari from './comps/Safari'

// 左右分屏版
class App extends Component {
	state = {
		mode: true,	// 模式开关，false表示浏览模式，true表示整编模式
	}

	changeMode = () => {
		this.setState((prevState) => ({ mode: !prevState.mode }));
	}

	render() {
		return (
			<div className="App">
				{this.state.mode ? <KnowledgeGraph /> : ''}
				<Safari mode={this.state.mode} changeMode={this.changeMode}/>
			</div>
		);
	}
}

// 仅图谱版
// class App extends Component {
// 	render() {
// 		return (
// 			<div className="App">
// 				<KnowledgeGraph className={'graphOnly'}/>
// 			</div>
// 		);
// 	}
// }

export default App;
